import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {IddTraining} from '../../../shared/interface/idd-training';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ReplaySubject} from 'rxjs';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';
import {FileBase64} from '../../../shared/components/file-drag-and-drop/file-drag-and-drop.component';
import {IddTrainingService} from '../../../shared/services/idd-training.service';
import {HttpErrorResponse} from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormHelperService} from '../../../shared/services/form-helper.service';

export interface AddStatementDialogData {
  iddTrainingObject: IddTraining;
}

@Component({
  selector: 'app-add-statement-dialog',
  templateUrl: './add-statement-dialog.component.html',
  styleUrls: ['./add-statement-dialog.component.scss']
})
export class AddStatementDialogComponent implements OnInit, OnDestroy {
  iddTrainingObject: IddTraining;
  addStatementForm: FormGroup;
  addStatementFormValid = false;
  fileNameControl: FormControl;
  fileContentControl: FormControl;
  dateOfEntryInRauControl: FormControl;
  processingRequest = false;
  formErrors: any = {};

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    public dialogRef: MatDialogRef<AddStatementDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddStatementDialogData,
    private fb: FormBuilder,
    private iddTrainingService: IddTrainingService,
    private snack: MatSnackBar,
    private formHelper: FormHelperService,
  ) {
    this.iddTrainingObject = data.iddTrainingObject;

    this.addStatementForm = fb.group({
      dateOfEntryInRau: this.dateOfEntryInRauControl = fb.control('', [Validators.required]),
      fileName: this.fileNameControl = fb.control('', [Validators.required]),
      fileContent: this.fileContentControl = fb.control('', [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.addStatementForm.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => this.addStatementFormValid = this.addStatementForm.valid)
    ;
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  fileSelected(fileBase64: FileBase64): void {
    if (fileBase64) {
      this.fileNameControl.setValue(fileBase64.filename);
      this.fileContentControl.setValue(fileBase64.base64);
    }
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  save(): void {
    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.addStatementForm, this.formErrors);
    this.formErrors = {};

    this.iddTrainingService.addStatement(this.iddTrainingObject.uuid, this.addStatementForm.value)
      .subscribe(() => {
        this.snack.open('Pomyślnie dodano oświadczenie', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close(true);
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas dodawania oświadczenia wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.addStatementForm, this.formErrors);
        }
      })
    ;
  }
}
